import PropTypes from 'prop-types';
export const megaMenuProductsPropTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    picture: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    }),
    labels: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.string,
    rating: PropTypes.shape({
      ratingScore: PropTypes.number,
      ratingCount: PropTypes.number
    }),
    price: PropTypes.shape({
      regular: PropTypes.number,
      sale: PropTypes.number,
      currency: PropTypes.string
    })
  }))
};